import cn from 'classnames';
import { CaseCardType } from '@lp/features/CasesBoard/components/CaseCard/constants';
import { BaseCaseInfo } from '@lp/features/CasesBoard/components/CaseCard/components/BaseCaseInfo/BaseCaseInfo';
import { getCardDateTime, getLogisticsStatuses } from '@features/components/CaseCard/utils';
import { LogisticsStatus } from '@features/components/CaseCard/Blocks/Quote/LogisticsStatus';
import styles from '@features/components/CaseCard/CaseCard.module.scss';
import { Case } from '@/api/apis/case';
import { getColorsByOrganType } from '@/utils/helpers';

type CaseInfoProps = {
  caseData: Case;
  isInitialCase?: boolean;
};

export const CaseInfo = ({ caseData, isInitialCase = false }: CaseInfoProps) => {
  const colors = getColorsByOrganType(caseData.organType);
  const { quoteStatus, routeStatus } = getLogisticsStatuses(caseData);
  const dateValue = getCardDateTime(caseData);

  return (
    <div className={cn(styles.cardLayout, 'relative flex flex-1 text-base-5 text-left rounded-b-none!', colors.bg70)}>
      <BaseCaseInfo
        cardType={CaseCardType.Base}
        color={colors.bg50}
        dateValue={dateValue}
        caseData={caseData}
        isReadOnly
      />
      <LogisticsStatus routeStatus={routeStatus} quoteStatus={quoteStatus} />
      {isInitialCase && (
        <div className="absolute top-0 right-0 rounded-tr-lg rounded-bl-lg bg-base-5 py-1 px-2.5 text-sm text-base-50">
          INITIAL
        </div>
      )}
    </div>
  );
};
